import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
// import { Post } from "../core/lib/types";
import Avatar from "react-avatar";
import Auth from '../core/services/auth';
import { getVideoThumb } from "../core/lib/utils";

function PostComponent({ id, user, profile, media, caption, vendor,
    location, thumbnail, createdAt, meta, user_action, posts, likedBy
    ,likes, pinnedBy, params, setParams, total }: any) {
    // navigate to Login
    const navigate = useNavigate();

    

    const routeTo = (post: any) => {
        //
        navigate('/post-view', { state: {post: post, posts: posts} })
      }
    //
    return (
                <div className='flex flex-row'>
                             <NavLink to={Auth.getUser()._id === user._id ? '/profile' : '/user-profile'} state={{ user: { _id: user._id, username: user.username, profile: profile } }}>
                            <div className="absolute flex flex-row items-start space-y-1 p-3 z-40">
                                   
                                        {(profile.profileImage) &&
                                            
                                            <div style={{width:'30px', height: '30px'}} className="border bg-gray-100 border-slate-400 rounded-full">
                                                <div className="bg-white block rounded-full  hover:-rotate-6 transform transition">
                                                <img alt='profile' className='rounded-full object-cover aspect-square' src={profile.profileImage.url}/>
                                                </div>
                                            </div>
                                            
                                        }
                                        
                                        { !(profile.profileImage) &&
                                            <Avatar round={true} size='30' name={user.username} />
                                        }
                                        
                                          <div className='ml-1.5 text-left text-white '>                                            
                                            <p className='text-xs font-medium text-dark mb-0 pb-0'>{user.username}</p>
                                          </div>
                                       
                                        
                            </div>
                            </NavLink> 
                            

                            
                            {  typeof(media) !== "undefined" && media.type  === 'image' ?
                              <img onClick={e=>routeTo({
                                id,
                                user,
                                caption,
                                media,
                                vendor,
                                location,
                                thumbnail,
                                createdAt,
                                meta,
                                user_action,
                                profile,
                                posts,
                                likedBy,
                                likes,
                                pinnedBy,
                            })} className=" h-auto max-w-full rounded-xl object-cover" src={media.url} alt=""/>
                              : typeof(media) !== "undefined" && media.type === 'video' ?
                              <video poster={getVideoThumb(media.url)} onClick={e=>routeTo({
                                id,
                                user,
                                caption,
                                media,
                                vendor,
                                location,
                                thumbnail,
                                createdAt,
                                meta,
                                user_action,
                                profile,
                                posts,
                                likedBy,
                                likes,
                                pinnedBy,
                            })} className=" h-auto max-w-full rounded-xl object-cover" >
                                <source src={media.url+'#t=0.001'}></source>
                                </video>
                              : ''
                            }
                        </div> 
    )
}

export default PostComponent